export default __webpack_public_path__ + "static/OYOY-1920x390-60fps-ca0a49923397c84719c35662b27d22f5.mp4";